import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Home, ShoppingBag, TrendingUp, FileText, HelpCircle, ChevronRight, ExternalLink } from 'lucide-react';
import { useGeo } from '../contexts/GeoContext';

const MobileMenu = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { isBrazil } = useGeo();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleNav = (path) => {
    onClose();
    navigate(path);
  };

  const menuItems = [
    { key: 'home', icon: Home, label: isBrazil ? 'Inicio' : 'Home', path: '/' },
    { key: 'products', icon: ShoppingBag, label: isBrazil ? 'Produtos' : 'Products', path: '/produtos' },
    { key: 'status', icon: TrendingUp, label: 'Status', path: '/status' },
    { key: 'feedbacks', icon: FileText, label: 'Feedbacks', path: '/feedbacks' },
    { key: 'support', icon: HelpCircle, label: isBrazil ? 'Suporte' : 'Support', path: '/suporte' },
  ];

  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={onClose}
      />

      {/* Drawer */}
      <div className={`fixed inset-y-0 right-0 z-[70] w-[85%] max-w-[380px] transition-transform duration-300 ease-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="h-full bg-gray-950/90 backdrop-blur-2xl border-l border-gray-800/40 flex flex-col" data-testid="mobile-menu">
          {/* Header */}
          <div className="flex items-center justify-between p-6 pb-4">
            <div>
              <p className="text-gray-500 text-[10px] font-bold tracking-[0.2em] uppercase">Menu</p>
              <p className="text-white text-xl font-bold mt-0.5">Cloud Cheats</p>
            </div>
            <button
              onClick={onClose}
              className="w-10 h-10 rounded-full bg-gray-800/60 flex items-center justify-center text-gray-400 hover:text-white transition-colors"
              data-testid="mobile-menu-close"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Menu Items */}
          <div className="flex-1 px-4 space-y-1.5 overflow-y-auto">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.key}
                  onClick={() => handleNav(item.path)}
                  className="w-full flex items-center gap-4 px-4 py-4 rounded-xl hover:bg-white/5 active:bg-white/10 transition-colors group"
                  data-testid={`menu-item-${item.key}`}
                >
                  <div className="w-10 h-10 rounded-xl bg-gray-800/60 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
                  </div>
                  <span className="text-gray-300 text-base font-medium group-hover:text-white transition-colors flex-1 text-left">{item.label}</span>
                  <ChevronRight className="w-4 h-4 text-gray-600 group-hover:text-gray-400 transition-colors" />
                </button>
              );
            })}
          </div>

          {/* Bottom Actions */}
          <div className="p-4 space-y-3 border-t border-gray-800/30">
            <button
              onClick={() => handleNav('/login')}
              className="w-full py-3.5 rounded-xl bg-white text-black font-bold text-sm flex items-center justify-center gap-2 hover:bg-gray-200 transition-colors"
              data-testid="menu-painel"
            >
              {isBrazil ? 'Painel' : 'Panel'} <ExternalLink className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
